import NewFrameButtons from './NewFrameButtons';
export default NewFrameButtons;
